import React, { useEffect, useState } from 'react';
import { axiosGetCall, axiosPostCall } from '../../../services/apisCall';
import Logger from '../../../lib/Logger';
const logger = new Logger('kycListTable');
import { renderErrorMessage, renderSuccessMessage } from '../../../lib/toastMessage';
import { CustomMenu } from '../../../components/menu/customMenu';

import { PaginationTable } from '../../../components/tables/paginationTable';
import TableFilters from './tableFilter';

import { TableCell, Box, List, ListItem, MenuItem, styled, useTheme, TextField, Button, Select } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { configFile } from '../../../config';
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
import { Icon } from '@iconify/react';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { ConfirmDialog } from 'src/components/custom-dialog';
import moment from 'moment';
import Iconify from 'src/components/iconify';
import CircularProgress from '@mui/material/CircularProgress';

const columns = [
  { id: 'name', label: 'Name', minWidth: 110, align: 'center' },
  { id: 'gateway_id', label: 'Gateway Id', minWidth: 110, align: 'center' },
  { id: 'country', label: 'Country', minWidth: 110, align: 'center' },
  { id: 'route', label: 'Route', minWidth: 110, align: 'center' },
  { id: 'sender_id', label: 'Sender Id', minWidth: 110, align: 'center' },
  { id: 'minimum_credit', label: 'Minimum Credits', minWidth: 110, align: 'center' },
  { id: 'create_date', label: 'Date & Time', minWidth: 200, align: 'center' },
  { id: 'smsc_host', label: 'Smsc Host', minWidth: 110, align: 'center' },
  { id: 'connection_type', label: 'Connection Type', minWidth: 110, align: 'center' },
  { id: 'username', label: 'Username', minWidth: 110, align: 'center' },
  { id: 'password', label: 'Password', minWidth: 110, align: 'center' },
  { id: 'sender_port', label: 'Sender Port', minWidth: 110, align: 'center' },
  { id: 'receiver_port', label: 'Receiver Port', minWidth: 110, align: 'center' },
  { id: 'is_dedicated', label: 'Dedicated', minWidth: 70, align: 'center' },
  { id: 'update_by', label: 'Update By', minWidth: 110, align: 'center' },
  { id: 'status', label: 'Status', minWidth: 110, align: 'center' },
  { id: 'actions', label: 'Actions', minWidth: 70, align: 'center' },
];

const CustomMenuItem = styled(MenuItem)(({ theme }) => ({
  // color: theme.palette.grey[200],
  gap: '8px',
}));
const menuItems = [
  { value: 0, label: 'Pending', id: '101' },
  { value: 1, label: 'Active', id: '102' },
  { value: 2, label: 'Only Report', id: '103' },
];

const formatHeartbeat = (timestamp) => {
  if (timestamp === null || timestamp === undefined || timestamp === '') return '—';

  const numericTimestamp = Number(timestamp);
  const normalizedTimestamp = Number.isFinite(numericTimestamp)
    ? (Math.abs(numericTimestamp) < 1e12 ? numericTimestamp * 1000 : numericTimestamp)
    : timestamp;
  const parsedTimestamp = moment(normalizedTimestamp);

  return parsedTimestamp.isValid() ? parsedTimestamp.format('YYYY-MM-DD HH:mm:ss') : '—';
};

const connectionLabel = (connected) => (connected === true ? 'Connected' : 'Not Connected');

export const GatewayList = ({ loadit, setUpdateUserId, forceLoad }) => {
  const theme = useTheme();
  const { URL_MAPPER: { console: consoleUrl } = {} } = configFile;
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);

  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [dedicatedUserId, setDedicatedUserId] = useState('');
  const [isDedicatedFilter, setIsDedicatedFilter] = useState('');
  const [load, setLoad] = useState(true);
  const [networkError, setNetworkError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [openStatus, setOpenStatus] = useState(false);
  const [status, setStatus] = useState();
  const [userData, setUserData] = useState([]);
  const [openAssign, setOpenAssign] = useState(false);
  const [assign, setAssign] = useState();
  const [openRemoveAssign, setOpenRemoveAssign] = useState(false);
  const [removeAssign, setRemoveAssign] = useState();
  const [openTestConnection, setOpenTestConnection] = useState(false);
  const [testingConnection, setTestingConnection] = useState(false);
  const [connectionTestResult, setConnectionTestResult] = useState(null);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleChange = (value) => setSearch(value);
  const applyGatewayFilters = ({ status, dedicatedUserId: filteredDedicatedUserId, isDedicated }) => {
    setStatusFilter(status);
    setDedicatedUserId(filteredDedicatedUserId);
    setIsDedicatedFilter(isDedicated);
    setPage(0);
    setLoad(true);
  };
  const resetGatewayFilters = () => {
    setStatusFilter('');
    setDedicatedUserId('');
    setIsDedicatedFilter('');
    setPage(0);
    setLoad(true);
  };
  const transformGatewayData = (gatewayList) => {
    return gatewayList.map((gateway) => ({
      ...gateway,
      smsc_host: gateway.gateway_details?.smsc_host,
      connection_type: gateway.gateway_details?.smsc_connection_type,
      username: gateway.gateway_details?.smsc_username,
      password: gateway.gateway_details?.smsc_password,
      sender_port: gateway.gateway_details?.smsc_port,
      receiver_port: gateway.gateway_details?.smsc_receive_port,
      originalData: gateway,
    }));
  };

  const getGatewayList = async () => {
    const skip = rowsPerPage * page;
    try {
      const params = { skip, limit: rowsPerPage };
      if (search) params.gatewayId = search;
      if (statusFilter !== '') params.status = statusFilter;
      if (dedicatedUserId.trim()) params.dedicatedUserId = dedicatedUserId.trim();
      if (isDedicatedFilter !== '') params.isDedicated = isDedicatedFilter;
      setNetworkError(false);
      const { gatewayList, totalGatewayListCount } = await axiosGetCall('getListGateway', params);
      const transformedData = transformGatewayData(gatewayList);
      setRows(transformedData);
      setCount(totalGatewayListCount);
    } catch (error) {
      logger.error('Gateway List', error);
      setNetworkError(true);
      setRows([]);
      setCount(0);
      renderErrorMessage(error?.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    // if (load) {
    setLoading(true);
    getGatewayList();
    setLoad(false);
    forceLoad(false);

    // }
  }, [load, loadit]);

  const handleClick = (event, user) => {
    setAnchorEl(event.currentTarget);
    setUserData(user);
  };
  const handleUpdateClick = () => {
    setAnchorEl(null);
    setUpdateUserId(userData.gateway_id);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCloseStatus = () => {
    setAnchorEl(null);
    setOpenStatus(false);
    setStatus();
  };
  const handleStatusClick = () => {
    setOpenStatus(true);
    setAnchorEl(null);
  };
  const handleAssignClick = () => {
    setOpenAssign(true);
    setAnchorEl(null);
  };
  const handleCloseAssign = () => {
    setAnchorEl(null);
    setOpenAssign(false);
    setAssign();
  };
  const handleRemoveAssignClick = () => {
    setOpenRemoveAssign(true);
    setAnchorEl(null);
  }

  const handleTestConnectionClick = async () => {
    setConnectionTestResult(null);
    setOpenTestConnection(true);
    setAnchorEl(null);
    if (!userData.gateway_id) return;

    setTestingConnection(true);
    try {
      const response = await axiosGetCall('testGatewayConnection', { gatewayId: userData.gateway_id });
      setConnectionTestResult({ success: true, data: response?.data ?? response });
    } catch (error) {
      logger.error('Gateway connection test', error);
      setConnectionTestResult({ success: false, message: error?.message || 'Unable to test gateway connection.' });
    } finally {
      setTestingConnection(false);
    }
  };

  const handleCloseTestConnection = () => {
    if (testingConnection) return;
    setOpenTestConnection(false);
    setConnectionTestResult(null);
  };

  const handleCloseRemoveAssign = () => {
    setAnchorEl(null);
    setOpenRemoveAssign(false);
    setRemoveAssign();
  }
  const handleConfirmStatus = async (gatewayId, status) => {
    try {
      const params = {
        gatewayId,
        newStatus: status,
      };
      const data = await axiosGetCall('changeStatus', params);
      renderSuccessMessage(data?.message);
      getGatewayList();
      setOpenStatus(false);
      setAnchorEl(null);
      setStatus();
    } catch (error) {
      logger.error('Gateway List change status', error);
      renderErrorMessage(error?.message);
    }
  };
  const handleConfirmAssign = async (gatewayId, assign) => {
    try {
      if (assign && userData.d_user_id.includes(assign)) {
        renderErrorMessage('This ID is already assigned!');
        return;
      }
      const params = {
        gatewayId: Array.isArray(gatewayId) ? gatewayId : [gatewayId],
        assignUserId: assign,
      };
      const data = await axiosGetCall('assignGateway', params);
      renderSuccessMessage(data?.message);
      getGatewayList();
      setOpenAssign(false);
      setAnchorEl(null);
      setAssign();
    } catch (error) {
      logger.error('Gateway List change status', error);
      renderErrorMessage(error?.message);
    }
  };

  const handleConfirmRemoveAssign = async (gatewayId,) => {
    try {
      const params = {
        gatewayId: Array.isArray(gatewayId) ? gatewayId : [gatewayId],
        removeUserId: removeAssign,
      }
      const data = await axiosGetCall('removeAssignGateway', params)
      renderSuccessMessage(data?.message)
      getGatewayList();
      setOpenRemoveAssign(false);
      setAnchorEl(null);
      setRemoveAssign();
    } catch (error) {
      logger.error("Gateway List change status", error);
      renderErrorMessage(error?.message)
    }
  }

  const tableFilter = (
    <TableFilters
      search={search}
      handleChange={handleChange}
      filterData={{ status: statusFilter, dedicatedUserId, isDedicated: isDedicatedFilter }}
      apply={applyGatewayFilters}
      reset={resetGatewayFilters}
      setLoad={setLoad}
      count={count}
      setPage={setPage}
    />
  );

  const ActionJsx = (id, align, value, ...other) => {
    const user = other[3];

    return (
      <TableCell
        key={id}
        align={align}
        sx={{
          color: 'grey.400',
          borderBottom: '0.5px dashed',
          borderColor: 'grey.300',
          size: 'small',
        }}
      >
        <MoreVertIcon
          sx={{ color: 'grey.700', cursor: 'pointer', height: '18px', width: '18px' }}
          aria-controls={open ? 'filters-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={(e) => handleClick(e, user)}
        />
      </TableCell>
    );
  };
  const Content = () => (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
      }}
    >
      <List>
        <ListItem
          sx={{
            display: 'flex',
            gap: '7px',
            fontWeight: 400,
            color: 'grey.700',
            '&:hover': {
              color: 'grey.800',
              backgroundColor: 'grey.300',
              cursor: 'pointer',
            },
          }}
          onClick={handleStatusClick}
        >
          <SwapHorizIcon sx={{ color: '#1976d2', height: '17px', margin: '5px' }} />
          Change Status
        </ListItem>
        <ListItem
          sx={{
            display: 'flex',
            gap: '7px',
            fontWeight: 400,
            color: 'grey.700',
            '&:hover': {
              color: 'grey.800',
              backgroundColor: 'grey.300',
              cursor: 'pointer',
            },
          }}
          onClick={handleUpdateClick}
        >
          <Icon icon="lucide:edit" style={{ color: '#1976d2', height: '17px', margin: '5px' }} />
          Update
        </ListItem>
        {userData.is_dedicated === 1 && (
          <ListItem
            sx={{
              display: 'flex',
              gap: '7px',
              fontWeight: 400,
              color: 'grey.700',
              '&:hover': {
                color: 'grey.800',
                backgroundColor: 'grey.300',
                cursor: 'pointer',
              },
            }}
            onClick={handleAssignClick}
          >
            <AssignmentIndIcon sx={{ color: '#1976d2', height: '17px' }} />
            assign to User
          </ListItem>
        )}
        {userData.is_dedicated === 1 && (
          <ListItem sx={{
            display: 'flex',
            gap: '7px',
            fontWeight: 400,
            color: 'grey.700',
            '&:hover': {
              color: 'grey.800',
              backgroundColor: 'grey.300',
              cursor: "pointer"
            }
          }}
            onClick={handleRemoveAssignClick}
          >
            <AssignmentIndIcon sx={{ color: "red", height: "17px" }} />
            Remove assign to User
          </ListItem>
        )}
          <ListItem sx={{
            display: 'flex',
            gap: '7px',
            fontWeight: 400,
            color: 'grey.700',
            '&:hover': {
              color: 'grey.800',
              backgroundColor: 'grey.300',
              cursor: "pointer"
            }
          }}
            onClick={handleTestConnectionClick}
          >
            <Icon icon="carbon:gateway-api" style={{ color: '#1976d2', height: '17px', margin: '5px' }} />
            Test Gateway Connections
          </ListItem>
      </List>
    </Box>
  );

  const statusjsx = (id, align, value, ...other) => {
    let label = '';
    let boxStyles = {};

    if (value === 0) {
      label = 'Pending';
      boxStyles = {
        color: '#D19244',
        backgroundColor: 'rgba(209, 146, 68, 0.20)',
      };
    } else if (value === 1) {
      label = 'Active';
      boxStyles = {
        color: '#50AB64',
        backgroundColor: 'rgba(40, 167, 69, 0.20)',
      };
    } else if (value === 2) {
      label = 'Only Report';
      boxStyles = {
        color: '#D19244',
        backgroundColor: 'rgba(209, 146, 68, 0.20)',
      };
    }

    return (
      <TableCell
        key={id}
        align={align}
        sx={{
          borderBottom: '0.5px dashed',
          borderColor: 'grey.300',
          background: 'transparent',
        }}
      >
        <Box
          sx={{
            borderRadius: '6px',
            fontWeight: 600,
            fontSize: '14px',
            display: 'inline-block',
            ...boxStyles,
            px: '12px',
            py: '2px',
          }}
        >
          {label}
        </Box>
      </TableCell>
    );
  };
  const dedicatedJsx = (id, align, value, row) => {
    let tooltipText = '';
    let label = value === 1 ? <InfoIcon /> : '-';
    if (value === 1) {
      if (Array.isArray(row.d_user_id) && row.d_user_id.length > 0) {
        tooltipText = `Dedicated to: ${row.d_user_id.join(', ')}`;
      } else {
        tooltipText = 'Dedicated gateway';
      }
    }

    return (
      <TableCell
        key={id}
        align={align}
        sx={{
          borderBottom: '0.5px dashed',
          borderColor: 'grey.300',
          background: 'transparent',
        }}
      >
        <Tooltip title={tooltipText} arrow>
          {label}
        </Tooltip>
      </TableCell>
    );
  };
  const createdatejsx = (id, align, value) => {
    const date = moment(Number(value));
    const formattedDate = date.format('D MMM, YYYY');
    const formattedTime = date.format('h:mm A');
    return (
      <TableCell
        key={id}
        align={align}
        sx={{
          color: 'grey.700',
          borderBottom: '0.5px dashed',
          borderColor: 'grey.300',
        }}
      >
        <>
          <Box>{value !== '' && value !== undefined && value !== null ? `${formattedDate} ${formattedTime}` : '-'}</Box>
        </>
      </TableCell>
    );
  };
  const routeJsx = (id, align, value) => {
    const ROUTE_LABELS = {
      transactional: 'Transactional',
      promotional: 'Promotional',
      explicit: 'Explicit',
      implicit: 'Implicit',
    };
    const label = ROUTE_LABELS[value] || value;

    return (
      <TableCell
        key={id}
        align={align}
        sx={{
          borderBottom: '0.5px dashed',
          borderColor: 'grey.300',
          background: 'transparent',
        }}
      >
        {label}
      </TableCell>
    );
  };

  const passwordjsx = (id, align, value) => {
    const handleClick = () => {
      navigator.clipboard.writeText(value);
      renderSuccessMessage('Password copied to clipboard!');
    };

    return (
      <TableCell
        key={id}
        align={align}
        sx={{
          color: 'grey.700',
          borderBottom: '0.5px dashed',
          borderColor: 'grey.300',
          cursor: 'pointer',
        }}
        onClick={handleClick}
      >
        <Iconify icon="prime:copy" width="20px" color={theme.palette.primary.main} />
      </TableCell>
    );
  };

  const ActionModals = () => {
    return <CustomMenu anchorEl={anchorEl} handleClose={handleClose} Content={Content} />;
  };
  return (
    <>
      <PaginationTable
        page={page}
        tableFilter={tableFilter}
        ActionJsx={ActionJsx}
        ActionModals={ActionModals}
        setLoad={setLoad}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        count={count}
        error={networkError}
        loading={loading}
        setLoading={setLoading}
        rows={rows}
        columns={columns}
        handleChange={handleChange}
        search={search}
        calculatedHeight={288}
        status={statusjsx}
        dedicatedJsx={dedicatedJsx}
        routeJsx={routeJsx}
        createdatejsx={createdatejsx}
        passwordjsx={passwordjsx}
      />
      <ConfirmDialog
        open={openStatus}
        onClose={handleCloseStatus}
        title="Change Status"
        content={
          <span>
            Are you sure you want to change status this Gateway {userData.gateway_id}.
            <Select
              id="change-status"
              defaultValue={userData.status}
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              fullWidth
              sx={{
                marginTop: '10px',
                '& .MuiSelect-select': {
                  paddingTop: '10px',
                  paddingBottom: '10px',
                  display: 'flex',
                  alignItems: 'center',
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  padding: 0,
                },
              }}
            >
              {menuItems.map((item) => {
                return (
                  <MenuItem
                    key={item.value}
                    value={item.value}
                    sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
                  >
                    <span>{item.label}</span>
                  </MenuItem>
                );
              })}
            </Select>
          </span>
        }
        action={
          <Button
            color="secondary"
            variant="contained"
            sx={{
              color: '#fff',
              height: '30px',
              backgroundColor: 'primary.main',
              '&:hover': {
                backgroundColor: 'primary.main',
              },
              boxShadow: 'none',
              marginRight: '10px',
            }}
            onClick={() => handleConfirmStatus(userData.gateway_id, status)}
          >
            Confirm
          </Button>
        }
      />
      <ConfirmDialog
        open={openAssign}
        onClose={handleCloseAssign}
        title="Assign Gateway"
        content={
          <span>
            Are you sure you want to assign this Gateway {userData.gateway_id} to user.
            <TextField
              required
              id="outlined-required"
              label="User ID"
              multiline
              maxRows={4}
              fullWidth
              value={assign}
              onChange={(e) => setAssign(e.target.value)}
              sx={{ marginTop: '10px' }}
            />
          </span>
        }
        action={
          <Button
            color="secondary"
            variant="contained"
            sx={{
              color: '#fff',
              height: '30px',
              backgroundColor: 'primary.main',
              '&:hover': {
                backgroundColor: 'primary.main',
              },
              boxShadow: 'none',
              marginRight: '10px',
            }}
            onClick={() => handleConfirmAssign(userData.gateway_id, assign)}
          >
            Confirm
          </Button>
        }
      />
      <ConfirmDialog
        open={openRemoveAssign}
        onClose={handleCloseRemoveAssign}
        title="Remove Assign user from Gateway"
        content={
          <span>
            Are you sure you want to remove this Gateway {userData.gateway_id} from the user.
            <TextField
              required
              id="outlined-required"
              label="User ID"
              multiline
              maxRows={4}
              fullWidth
              value={removeAssign}
              onChange={(e) => setRemoveAssign(e.target.value)}
              sx={{ marginTop: "10px" }}
            />
          </span>
        }
        action={
          <Button
            color="secondary"
            variant="contained"
            sx={{
              color: '#fff',
              height: '30px',
              backgroundColor: 'primary.main',
              '&:hover': {
                backgroundColor: 'primary.main',
              },
              boxShadow: "none",
              marginRight: '10px'
            }}
          onClick={() => handleConfirmRemoveAssign(userData.gateway_id)}
          >Confirm
          </Button>
        }
      />
      <ConfirmDialog
        open={openTestConnection}
        onClose={handleCloseTestConnection}
        title={`Connection Status of Gateway ID - ${userData.gateway_id || '—'}`}
        content={
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Box>Gateway: <strong>{userData.name || '—'}</strong></Box>
            {connectionTestResult && (
              connectionTestResult.success ? (
                <Box role="status" sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
                  {['sending', 'reporting'].map((connectionType) => {
                    const connection = connectionTestResult.data?.[connectionType] || {};
                    return (
                      <Box key={connectionType} sx={{ pl: 1, borderLeft: 2, borderColor: 'divider' }}>
                        <Box sx={{ fontWeight: 600, textTransform: 'capitalize' }}>{connectionType}</Box>
                        <Box>
                          Connection:{' '}
                          <Box component="strong" sx={{ color: connection.connected === true ? 'success.main' : 'error.main' }}>
                            {connectionLabel(connection.connected)}
                          </Box>
                        </Box>
                        <Box>Last connect time: <strong>{formatHeartbeat(connection.lastHeartbeat)}</strong></Box>
                          <>
                            <Box>Expected sessions: <strong>{connection.expectedSessions ?? '—'}</strong></Box>
                            <Box>Connected sessions: <strong>{connection.connectedSessions ?? '—'}</strong></Box>
                          </>
                      </Box>
                    );
                  })}
                </Box>
              ) : (
                <Box role="alert" sx={{ mt: 1, color: 'error.main', overflowWrap: 'anywhere' }}>
                  {connectionTestResult.message}
                </Box>
              )
            )}
          </Box>
        }
      />
    </>
  );
};
